
/**
 * 트윗 태그 정보
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemTags = {
  hashtags?: string[];
};
